import React from "react";
import {Box, Typography} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";

const BulkUploadProcessedStatusBar = ({
                                          totalProcessedDocuments,
                                          totalUploadedDocuments,
                                          currentStatus
                                      }) => {
    const processed = Number(totalProcessedDocuments) || 0;
    const total = Number(totalUploadedDocuments) || 0;
    const failed = Math.max(total - processed, 0);

    const processedPercentage = total > 0 ? (processed / total) * 100 : 0;
    const failedPercentage = total > 0 ? (failed / total) * 100 : 0;

    const uploadStatusInfo =
        `${totalProcessedDocuments} - Successful\n` +
        `${totalUploadedDocuments-totalProcessedDocuments} - Failed\n`+
        `${totalUploadedDocuments} - Total\n`;


    const normalizedStatus = currentStatus?.toUpperCase();
    if (normalizedStatus !== 'COMPLETED') {
        return (
            <Box
                sx={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                }}
                onClick={(event) => {
                    event.stopPropagation();
                }}
            >
                {normalizedStatus === 'UPLOAD_FAILED' ?
                   ( <Tooltip title="Failed to upload file" arrow placement="top" enterTouchDelay={0}>
                        <Typography variant="body2" sx={{fontSize: '0.75rem'}}>
                            N/A
                        </Typography>
                    </Tooltip>)
                    :
                    (<Typography variant="body2" sx={{ fontSize: '0.75rem' }}>
                        -
                    </Typography>)}
            </Box>
        );
    }
    return (
        <Tooltip
            title={uploadStatusInfo}
            slotProps={{
                tooltip: {
                    sx: {
                        bgcolor: "#FFFFFF",
                        color: "#3F4756",
                        border: "1px solid #E5E7EB",
                        borderRadius: "12px",
                        boxShadow: "0px 4px 12px rgba(16, 24, 40, 0.12)",
                        whiteSpace: "pre-line",
                        fontSize: "12px",
                        fontWeight: 400,
                        fontFamily: '"Inter", "Roboto", sans-serif',
                    },
                }
            }}
        >
        <Box sx={{width: "100%", marginTop: "0.5rem"}}>
            {/* Counts */}
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: processed ? "space-between" : "flex-end",
                    mb: 0.5,
                }}
            >{!!processed &&
                <Typography
                    variant="caption"
                >
                    <Box variant="span" sx={{
                        fontSize: 12,
                        color: "#00875A",
                        display: "inline",
                    }}>{processed} </Box>
                    / {total}
                </Typography>}
                {!!failed  &&
                    <Typography
                        variant="caption"
                    >
                        <Box variant="span" sx={{
                            fontSize: 12,
                            color: "#EF4444",
                            display: "inline",
                        }}>{failed} </Box> / {total}
                    </Typography>}

            </Box>

            {/* Status bar */}
            <Box
                sx={{
                    width: "100%",
                    height: "4px",
                    display: "flex",
                    overflow: "hidden",
                    borderRadius: "2px",
                    backgroundColor: "#E5E7EB",
                }}
            >
                {/* Processed */}
                <Box
                    sx={{
                        width: `${processedPercentage}%`,
                        backgroundColor: "#00875A",
                    }}
                />

                {/* Failed / Remaining */}
                <Box
                    sx={{
                        width: `${failedPercentage}%`,
                        backgroundColor: "#EF4444",
                    }}
                />
            </Box>
        </Box>
        </Tooltip>
    );
};

export default BulkUploadProcessedStatusBar;